// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"Layout_header-wrapper__1VbDD","header-shape":"Layout_header-shape__1dVde"};